import { createSlice } from "@reduxjs/toolkit";
import isEqual from 'fast-deep-equal'; // Import the deep equal function

const contentSlice = createSlice({
  name: 'content',
  initialState: {},
  reducers: {
    setAplusData: (state, action) => {
      state.contentData = action.payload; // Set data where needed
    },
    removeModule: (state, action) => {
      const { id } = action.payload;
    
      if (state.contentData) {
        const updatedContentData = { ...state.contentData };
    
        Object.keys(updatedContentData).forEach((key) => {
          const index = updatedContentData[key].findIndex((module) => module.id === id);
    
          // Remove the item if found
          if (index !== -1) {
            updatedContentData[key].splice(index, 1);
          }
    
          // Remove the key if the array is empty and more than one key exists
          if (updatedContentData[key].length === 0 && Object.keys(updatedContentData).length > 1) {
            delete updatedContentData[key];
          }
        });
    
        state.contentData = updatedContentData;
      }
    },    
    updateModule: (state, action) => {
      const { id, ...newContent } = action.payload;
      if (state.contentData) {
        Object.keys(state.contentData).forEach((moduleType) => {
          state.contentData[moduleType] = state.contentData[moduleType].map((module) => {
            if (module.id === id) {
              // Compare existing content with new content
              const currentContent = module.content; // Assuming the current content is stored under 'content'
              
              if (!isEqual(currentContent, newContent)) {
                console.log(`Updating module with ID: ${id} in ${moduleType}`);
                return { ...module, content: newContent }; // Update if they are not equal
              } else {
                console.log(`No changes detected for module with ID: ${id} in ${moduleType}`);
              }
            }
            return module; // Return the module unchanged if IDs don't match
          });
        });
      }
    },
  },
});

// Export actions and reducer
export const { setAplusData, removeModule, updateModule } = contentSlice.actions;
export default contentSlice.reducer;
